import React, { useRef } from "react";
import {
    IonToolbar, IonButtons, IonButton,
    IonImg, IonNote, IonPage, IonContent, useIonViewDidEnter, IonHeader, IonText, useIonAlert
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import required modules
import { Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import './Welcome.css';

import { useAppSelector, useAppDispatch } from '../../services/redux/hook';
import { createStellarKeys } from "../../services/stellar/stellar-utils";
import { setWalletInfo } from "../../services/redux/slices/walletInfo/wallet";
import { setUser } from "../../services/redux/slices/user/user";
import { setFlowContext } from "../../services/redux/slices/flow-context/flowContext";
import { WalletInfoState } from "../../types/types";

const WelcomePage: React.FC<any> = () => {

    const { t, i18n } = useTranslation();
    const history = useHistory();
    const language = useAppSelector((state) => state.language);
    const user = useAppSelector((state) => state.user);
    const walletInfo = useAppSelector((state) => state.walletInfo);
    const dispatch = useAppDispatch();

    const sliderData = [
        {
            title: t('wallet-init.HEADER_SLIDE_1'),
            subtitle: t('wallet-init.SUB_HEADER_SLIDE_1'),
            image: "/assets/img/ebioro-vertical-blue-orange.svg",
            hidden_title: false,
            hidden_subtitle: true,
        },
        {
            title: t('wallet-init.HEADER_SLIDE_2'),
            subtitle: t('wallet-init.SUB_HEADER_SLIDE_2'),
            image: "/assets/img/buy_sell.svg",
            hidden_title: false,
            hidden_subtitle: false,
        },

        {
            title: t('wallet-init.HEADER_SLIDE_3'),
            subtitle: t('wallet-init.SUB_HEADER_SLIDE_3'),
            image: "/assets/img/international.svg",
            hidden_title: false,
            hidden_subtitle: false,
        },

        {
            title: t('wallet-init.HEADER_SLIDE_4'),
            subtitle: t('wallet-init.SUB_HEADER_SLIDE_4'),
            image: "/assets/img/safety.svg",
            hidden_title: false,
            hidden_subtitle: false,
        },

    ]


    useIonViewDidEnter(() => {
        let newUser = { ...user };
        newUser.locale = language;
        dispatch(setUser(newUser));
    });

    async function login() {
        
        history.push('/login');
    }

    async function getStarted() {

        const [public_key, master_key] = createStellarKeys();
        const [device_public_key, device_master_key] = createStellarKeys();

        const newWalletInfo:WalletInfoState = { ...walletInfo };
        newWalletInfo.account_key = public_key;
        newWalletInfo.account_private_key = master_key;
        newWalletInfo.device_key = device_public_key;
        newWalletInfo.device_private_key = device_master_key;
        newWalletInfo.has_key = true;

        dispatch(setWalletInfo(newWalletInfo));

        // Set the flow context for registration
        dispatch(setFlowContext({ 
            flow: 'registration', 
            redirectAfterPin: '/signup/name' 
        }));

        history.push('/pin/create');

    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton  onClick={() => login()} className="restore_btn" color='danger'>
                            {t('wallet-init.RECOVER_BUTTON')}
                        </IonButton>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton color="primary" onClick={() => getStarted()} className="create-wallet">
                            {t('wallet-init.START_BUTTON')}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent scrollY={false} fullscreen={true}>
                <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    spaceBetween={30}
                    pagination={{
                        clickable: true,
                    }}
                    className="welcome-swiper"
                >
                    {
                        sliderData.map((slide, index) => {

                            return (

                                <SwiperSlide key={index} className="swiperSlide">

                                    <div className="welcome-card">
                                        <IonImg src={slide.image} className="welcome-image" />
                                        <IonText hidden={slide.hidden_title} color='primary'>
                                            <h4 className="h4_pad"> {slide.title}</h4>

                                        </IonText>
                                        <IonText className="welcome-subtitle" hidden={slide.hidden_subtitle}>
                                            <IonNote >{slide.subtitle}</IonNote>
                                        </IonText>

                                    </div>
                                </SwiperSlide>

                            )
                        })
                    }

                </Swiper>
            </IonContent>
        </IonPage>
    )

}

export default WelcomePage

